"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningCard = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../../cards/CardType");
const Resources_1 = require("../../Resources");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const SpaceBonus_1 = require("../../SpaceBonus");
const Tags_1 = require("../../cards/Tags");
const TileType_1 = require("../../TileType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const AresHandler_1 = require("../../ares/AresHandler");
class MiningCard extends Card_1.Card {
    constructor(name, cost, metadata) {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name,
            tags: [Tags_1.Tags.BUILDING],
            cost,
            metadata,
        });
        this.bonusResource = undefined;
    }
    canPlay(player) {
        return this.getAvailableSpaces(player).length > 0;
    }
    isAres() {
        return this.name === CardName_1.CardName.MINING_AREA_ARES || this.name === CardName_1.CardName.MINING_RIGHTS_ARES;
    }
    getAdjacencyBonus(bonusType) {
        if (this.isAres()) {
            return { bonus: [bonusType] };
        }
        return undefined;
    }
    getAvailableSpaces(player) {
        const game = player.game;
        return game.board.getAvailableSpacesOnLand(player)
            .filter((space) => space.bonus.includes(SpaceBonus_1.SpaceBonus.STEEL) || space.bonus.includes(SpaceBonus_1.SpaceBonus.TITANIUM))
            .filter((space) => space.tile === undefined)
            .filter((space) => {
            if (game.gameOptions.aresExtension) {
                const cost = AresHandler_1.AresHandler.computeAdjacencyCosts(game, space, true);
                const availableProductionUnits = player.getAvailableProductionUnits();
                return availableProductionUnits >= cost.production && player.canAfford(cost.megacredits);
            }
            else {
                return true;
            }
        });
    }
    getSelectTitle() {
        let result = 'Select a space with a steel or titanium bonus';
        if (this.name === CardName_1.CardName.MINING_AREA || this.name === CardName_1.CardName.MINING_AREA_ARES) {
            result += ' adjacent to one of your tiles';
        }
        return result;
    }
    getTileType(bonus) {
        if (this.isAres()) {
            return bonus === SpaceBonus_1.SpaceBonus.STEEL ? TileType_1.TileType.MINING_STEEL_BONUS : TileType_1.TileType.MINING_TITANIUM_BONUS;
        }
        if (this.name === CardName_1.CardName.MINING_RIGHTS) {
            return TileType_1.TileType.MINING_RIGHTS;
        }
        return TileType_1.TileType.MINING_AREA;
    }
    produce(player) {
        if (this.bonusResource === undefined) {
            return;
        }
        player.addProduction(this.bonusResource, 1, { log: true });
    }
    play(player) {
        return new SelectSpace_1.SelectSpace(this.getSelectTitle(), this.getAvailableSpaces(player), TileType_1.TileType.MINING_AREA, (space) => {
            let grantTitanium = space.bonus.includes(SpaceBonus_1.SpaceBonus.TITANIUM);
            if (grantTitanium && space.bonus.includes(SpaceBonus_1.SpaceBonus.STEEL)) {
                player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                    return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption("Increase titanium production 1 step", "Select", () => {
                        grantTitanium = true;
                        return undefined;
                    }), new SelectOption_1.SelectOption("Increase steel production 1 step", "Select", () => {
                        grantTitanium = false;
                        return undefined;
                    }));
                }));
            }
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                this.bonusResource = grantTitanium ? Resources_1.Resources.TITANIUM : Resources_1.Resources.STEEL;
                this.produce(player);
                return undefined;
            }));
            const spaceBonus = grantTitanium ? SpaceBonus_1.SpaceBonus.TITANIUM : SpaceBonus_1.SpaceBonus.STEEL;
            player.game.addTile(player, space.spaceType, space, { tileType: this.getTileType(spaceBonus) });
            space.adjacency = this.getAdjacencyBonus(spaceBonus);
            return undefined;
        });
    }
}
exports.MiningCard = MiningCard;
//# sourceMappingURL=MiningCard.js.map